import { getProductDetails } from '../../apiCalls/urls/urlFunction';
import { isDiscountedProduct } from '../../hooks/utilsFn/utilsFn';

export const validateOutOfStock = (isRange, front, denom) => {
  let response = {
    outOfStockStatus: false,
    rangeDenominationStatus: false,
  };

  if (isRange == 1 && front !== 0) {
    response.outOfStockStatus = true;
    response.rangeDenominationStatus = true;
  } else if (isRange == 1 && front == 0 && denom?.length < 1) {
    response.rangeDenominationStatus = true;
    response.outOfStockStatus = false;
  } else if (isRange !== 1 && front == 0 && denom?.length > 0) {
    response.outOfStockStatus = false;
    response.rangeDenominationStatus = false;
  } else if (isRange !== 1 && front !== 0) {
    response.outOfStockStatus = true;
    response.rangeDenominationStatus = false;
  } else if (isRange !== 1 && front == 0 && denom?.length < 1) {
    response.outOfStockStatus = true;
    response.rangeDenominationStatus = false;
  }

  // THis Logic is work properly
  // if (apiId == 5 && front !== 0) {
  //     response.outOfStockStatus = true;
  //     response.rangeDenominationStatus = true;
  // } else if (apiId == 5 && front == 0 && denom?.length < 1) {
  //     response.rangeDenominationStatus = true;
  //     response.outOfStockStatus = false;
  // } else if (apiId !== 5 && front == 0 && denom?.length > 0) {
  //     response.outOfStockStatus = false;
  //     response.rangeDenominationStatus = false;
  // } else if (apiId !== 5 && front !== 0) {
  //     response.outOfStockStatus = true;
  //     response.rangeDenominationStatus = false;
  // } else if (apiId !== 5 && front == 0 && denom?.length < 1) {
  //     response.outOfStockStatus = true;
  //     response.rangeDenominationStatus = false;
  // }

  return response;

  // return response;
  /**
   * denomination.api_id == 5 && denomination.front == 0 => Card Range
   * denomination.api_id == 5 &&  denomination.front !== 0 => Currently Out Of Stock
   * denomination.api_id !== 5 && denomination.front !== 0 => Currently Out Of Stock
   * denomination.api_id !== 5 && denomination.front === 0 => Currently Out Of Stock
   **/
};

export const isProductLive = (flag) => {
  if (parseInt(flag) !== 0) {
    return true;
  }
  return false;
};

export const fetchProductById = async (urlId) => {
  try {
    const productApiResponse = await getProductDetails(urlId);
    if (productApiResponse?.['status'] && productApiResponse?.['statusCode']) {
      return productApiResponse.data;
    }
  } catch (error) {}
};

export const isDenominationAvailable = (denoData) => {
  let response = {
    isDenominationAvailableStatus: true,
  };
  if (!denoData?.length) {
    response.isDenominationAvailableStatus = false;
  }
  return response;
};

export const createDenominationData = (data, isShowUniqueDiscount = false) => {
  const denominationData = data?.denomination;
  let discountedValues = undefined;
  const { productType, discount } = isDiscountedProduct(data.discount, data?.cashback_amount);

  if (isShowUniqueDiscount) {
    discountedValues = generateUniqueDiscounts(0, discount, denominationData?.length);
  }

  const newDenoData = denominationData.map((item, idx) => {
    return {
      AMOUNT: item?.amount,
      DISCOUNT: isShowUniqueDiscount ? discountedValues?.[idx] : discount,
      QUANTITY: 0,
      TOTAL: 0,
      PRODUCT_CODE: item?.PRODUCTCODE,
      PRODUCT_GUID: item?.ProductGuid,
      PRODUCT_ID: item?.product_id,
      SUB_PRODUCT_ID: item?.subproduct_id,
      SKU_ID: item?.skuID,
      ISCASHBACK_PRODUCT: productType === 'Cashback' ? true : false,
      PRODUCT_TYPE: productType,
      CASHBACK_AMOUNT: discount,
      TOTALGROSSAMOUNT: 0,
    };
  });
  return newDenoData;
};

export const getHighestDiscount = (product) => {
  if (isDenominationAvailable(product?.['denomination'])) {
    const highestDiscountItem = product?.['denomination']?.reduce((max, item) =>
      item?.discountDenomination > max?.discountDenomination ? item : max
    );

    return highestDiscountItem;
  } else {
    return product?.discount;
  }
};

export const generateUniqueDiscounts = (min, max, count, precision = 2) => {
  const discounts = new Set();

  while (discounts.size < count) {
    let random = Math.random() * (max - min) + min;

    // randomly decide if integer or float
    const isInteger = Math.random() > 0.5;

    if (isInteger) {
      random = Math.floor(random);
    } else {
      random = parseFloat(random.toFixed(precision));
    }

    discounts.add(random);
  }

  return Array.from(discounts);
};
